import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import BaseAppService from '../../../../application/platform/sdp/base/base-app-service';
import OfficialDiaryAppService from '../../../../application/platform/sdp/official-diary/official-diary-app-service';
import SubmissionPublicationAppService from '../../../../application/platform/sep/submission-publication/submission-publication-app-service';
import { useFeedback } from '../../../../hooks/use-feedback';
import { ACTION_TYPES, useDashboardDispatch } from "./dashboard-context";

const RECENT_ITEMS_PAGE = { page: 0, pageSize: 5 };

export const useDashboardController = () => {
    const navigate = useNavigate();
    const { showError, withLoading } = useFeedback();
    const dispatch = useDashboardDispatch();

    useEffect(() => {
        loadData();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    async function loadData() {
        await withLoading(async () => {
            try {
                const [dashboard, officialDiaries, submissions] = await Promise.all([
                    BaseAppService.getDashboard(),
                    OfficialDiaryAppService.get(RECENT_ITEMS_PAGE),
                    SubmissionPublicationAppService.get(RECENT_ITEMS_PAGE)
                ]);
                dispatch({ type: ACTION_TYPES.setDashboardDetail, payload: dashboard });
                dispatch({ type: ACTION_TYPES.setOfficialDiaryItems, payload: officialDiaries });
                dispatch({ type: ACTION_TYPES.setSubmissionPublicationItems, payload: submissions });
            } catch (error: any) {
                showError('Não foi possível carregar o painel de controle', error);
            }
        });
    }

    function handleTabChange(event: React.SyntheticEvent, newTabIndex: number) {
        dispatch({ type: ACTION_TYPES.setTabIndex, payload: newTabIndex });
    }

    function navigateToSubmissionPublications() {
        navigate('/remessas-publicacao');
    }

    function navigateToSubmissionPublicationDetail(id: number) {
        navigate(`/remessas-publicacao/detalhes/${id}`);
    }

    function navigateToOfficialDiaryDetail(id: number) {
        navigate(`/diario-oficial/detalhes/${id}`);
    }

    return {
        handleTabChange,
        navigateToSubmissionPublications,
        navigateToSubmissionPublicationDetail,
        navigateToOfficialDiaryDetail
    };
}
